// extracted by mini-css-extract-plugin
module.exports = {"simple_card":"SimpleCard_simple_card__2dvpX","alignRight":"SimpleCard_alignRight__uHASN"};